import React from 'react';
import { useRecordContext, ArrayField } from 'react-admin';

export const TagsArrayField = ({ source = 'tags', ...props }) => {
    const record = useRecordContext(props);

    const recordWithColors = React.useMemo(() => {
        if (!record) return undefined;

        const tags = Array.isArray(record[source]) ? record[source] : [];

        return {
            ...record,
            [source]: tags.map(tag => ({
                ...tag,
                category: {
                    ...tag.category,
                    color: record.color,
                },
            })),
        };
    }, [record, source]);

    if (!recordWithColors) return null;

    return <ArrayField {...props} source={source} record={recordWithColors} />;
};
